import { Box, Grid, Skeleton } from '@mui/material';

export default function CardSkelton({
  variant = 'rectangular',
  width = 100,
  height = 100,
  spacing,
  sx = {},
  borderRadius = 0,
  mutliCard = { count: 1, size: { xs: 12, sm: 6, md: 3, lg: 2 } },
}) {
  return mutliCard ? (
    <Grid container spacing={spacing || 1}>
      {Array.from({ length: mutliCard.count || 1 }).map((e, i) => (
        <Grid item {...(mutliCard?.size ? mutliCard.size : {})} key={i}>
          <Skeleton
            variant={variant}
            width={width}
            height={height}
            sx={{ ...sx, borderRadius: borderRadius }}
            key={i}
          />
        </Grid>
      ))}
    </Grid>
  ) : (
    <Skeleton variant={variant} width={width} height={height} sx={{ ...sx, borderRadius: borderRadius }} />
  );
}
